import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { InfoDialogData } from './info-dialog-data';

@Component({
  selector: 'cc-app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: InfoDialogData) {}

  ngOnInit() {}
}
